import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";
import { LIFESTYLE } from "@/lib/site";

export const Community = () => (
  <section
    id="community"
    data-testid="community-section"
    className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36"
  >
    <Reveal className="max-w-2xl">
      <Eyebrow>The community</Eyebrow>
      <h2 className="mt-5 font-editorial text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
        Scrubs off,{" "}
        <span className="font-normal italic text-terracotta-dark">personality on</span>
      </h2>
      <p className="mt-5 text-base leading-relaxed text-clay sm:text-lg">
        On STETH, you're more than your credentials. Profiles lead with the life
        outside the hospital: the runs, the recipes, the trails, the playlists.
      </p>
    </Reveal>

    <div className="mt-14 grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-4">
      {LIFESTYLE.map((p, i) => (
        <motion.figure
          key={p.tag}
          data-testid={`community-card-${i}`}
          initial={{ opacity: 0, y: 56 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.75, delay: (i % 4) * 0.1, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ y: -10 }}
          className={`group relative overflow-hidden rounded-[1.8rem] border border-hairline shadow-[0_25px_55px_-30px_rgba(36,26,22,0.45)] ${
            i === 0 ? "col-span-2 row-span-2 aspect-[4/3] md:aspect-auto" : "aspect-[3/4]"
          } ${i === 1 ? "md:mt-12" : ""} ${i === 3 ? "md:mt-12" : ""} ${i === 4 ? "col-span-2 aspect-[4/3] md:col-span-1 md:aspect-[3/4] md:-mt-6" : ""}`}
        >
          <img
            src={p.src}
            alt={p.alt}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-ink/70" />
          <figcaption className="absolute bottom-4 left-4">
            <span className="inline-block rounded-full bg-cream/90 px-3.5 py-1.5 text-xs font-extrabold text-ink backdrop-blur-sm">
              {p.tag}
            </span>
          </figcaption>
        </motion.figure>
      ))}
    </div>
  </section>
);
